import { Layout, Tabs } from 'antd';
import './App.css';
import { AuthProvider, useAuth } from './stores/LoginFree';
import AppContent from './views/AppContent';

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;